import { z } from 'zod';

export const ForgotPasswordFormSchema = z.object({
  username: z.string().min(1, 'Email or username is required'),
});

export type ForgotPasswordFormData = z.infer<typeof ForgotPasswordFormSchema>;
